import { classNames } from "../../helper";
import { Loader, Loading, PreLoaderContainer, PreLoaderPosition, PreLoaderStatus } from "./Components";

export const PreLoader = ({show, disableBackground, small}) => {
    return (
        <PreLoaderContainer className={classNames([
            show && 'show',
            disableBackground && 'no-bg'   
        ])}>
            <PreLoaderStatus>
                <PreLoaderPosition>
                    <Loader className={classNames([small && "small"])}>
                        <span></span>
                    </Loader>
                </PreLoaderPosition>
            </PreLoaderStatus>
        </PreLoaderContainer>
    );
}

export const DataLoading = ({small, verySmall}) => {
    return (
        <PreLoaderPosition className={classNames([small && "small", verySmall && "very-small", "loading-data"])}>
            <Loading className={classNames([small && "small", verySmall && "very-small"])}>
                <span></span>
            </Loading>
        </PreLoaderPosition>
    );
}

